
import React, { useState, useEffect, useRef, useContext } from "react";
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch, Redirect, Link } from "react-router-dom";
import _ from 'lodash'
import Swal from "sweetalert2"
import Notify from 'react-notification-alert';


import { UserContext } from "context/auth";

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";

import routes from "routes.js";
import sound from "../assets/sounds/notify.mp3";

var ps;
let firebaseMessaging = window.firebaseMessaging

function Admin(props) {
  
  let { user } = useContext(UserContext)
  let { loggedIn } = user

  let [adminRoutes, setRoutes] = useState(routes)

  let [backgroundColor, setBackgroundColor] = useState("black")
  let [activeColor, setActiveColor] = useState("info")
  let [sidebarMini, setSidebarMini] = useState(false)
  
  let mainPanel = useRef()
  let notify = useRef()
  
  let audio = new Audio(sound)

  // filter the routes based on auth user permisions 
  useEffect(() => {
    
    console.log();
    // if (!loggedIn) return

    let finalRoutes = []
    let { permissons } = user
    
    _.forEach(adminRoutes, route => {

      if (route.path === '/staff' && !permissons?.CanAddStaff) return

      if (route.path === '/form-builder' && !permissons?.CanGenerateForm) return

      if (route.path === '/tasks' && !permissons?.CanTakeAction) return

      if (route.path === '/all-tickets' && !permissons?.CanSeeAllTickets) return

      finalRoutes.push(route)
    })

    setRoutes(finalRoutes)
    
  }, [routes, user])

  useEffect(() => {}, [adminRoutes])

  useEffect(() => {

    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(mainPanel);
    }

    return () => {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.documentElement.className += " perfect-scrollbar-off";
        document.documentElement.classList.remove("perfect-scrollbar-on");
      }
    }
  }, [])

  useEffect(() => {
    if (props.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      mainPanel.scrollTop = 0;
    }
  })

  // show local notification (new Task)
  useEffect(() => {
    let unsubscribeNotification = firebaseMessaging?.onMessage(payload => {

      var options = {
        place: 'tr',
        message: (
          <Link to='/admin/tasks' className='text-white'>
            <div>{payload.data.body}</div>
          </Link>
        ),
        type: 'primary',
        autoDismiss: 5,
        icon: "nc-icon nc-bell-55",
      };

      audio.play()
      notify.current.notificationAlert(options)

    })

    return () => unsubscribeNotification && unsubscribeNotification()
  }, [])

  let getRoutes = routes => {
    
    return routes.map((prop, key) => {

      if (prop.collapse) {
        return getRoutes(prop.views);
      }

      if (prop.layout === "/admin") {

        if (!loggedIn)
          return <Redirect key={key} to='/auth/login' />

        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );

      } else {
        return null;
      }

    })

  }

  let handleActiveClick = color => setActiveColor(color)

  let handleBgClick = color => setBackgroundColor(color)

  let handleMiniClick = () => {
    if (document.body.classList.contains("sidebar-mini")) {
      setSidebarMini(true)
    } else {
      setSidebarMini(false)
    }
    document.body.classList.toggle("sidebar-mini");
  }

  return (
    <div className="wrapper">

      <Notify ref={notify} />

      <Sidebar
        {...props}
        routes={adminRoutes}
        bgColor={backgroundColor}
        activeColor={activeColor}
      />

      <div className='main-panel' id="adminContent" ref={(ref) => { mainPanel = ref }}>
        <AdminNavbar {...props} handleMiniClick={handleMiniClick} />

        <Switch>
          {getRoutes(adminRoutes)}
        </Switch>

      </div>
    </div>
  )
}

export default Admin;
